"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class AvatarNotPermittedError extends client_library_1.ExtendableError {
    constructor(avatarId) {
        super(`User does not have permission to pick avatar with avatarId=${avatarId}`);
    }
}
exports.default = AvatarNotPermittedError;
//# sourceMappingURL=AvatarNotPermittedError.js.map